import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const Section = styled.div`
  border-bottom: 6px solid ${({ theme }) => theme.customColors.borderGreyLighter};
  margin: 0;
  padding: 20px;

  ${media.md`
    border: none;
    margin: 0;
    padding: 20px 0 0;
  `}
`;
